import React, { useEffect, useMemo } from 'react'

import { DatePicker, Select, Space } from 'antd'
import {
  $financeManagers,
  financeManagerMounted,
} from '../../../../billing/withdrawals/list/model'
import { useUnit } from 'effector-react'
import dayjs from 'dayjs'
import { RangePickerProps } from 'antd/es/date-picker'
import { TimeRangePickerProps } from 'antd'
import {
  endOfMonth,
  endOfQuarter,
  startOfMonth,
  startOfQuarter,
  subMonths,
  subQuarters,
} from 'date-fns'

export type FiltersValue = {
  userIds?: string[]
  datePeriod?: RangePickerProps['value']
}

type Props = {
  value: FiltersValue
  onChange: (payload: FiltersValue) => void
  hasFullAccess: boolean
  classname?: string
}

const { RangePicker } = DatePicker

export const ProcessingFilters: React.FC<Props> = ({
  value,
  onChange,
  hasFullAccess,
  classname,
}) => {
  const financeManagers = useUnit($financeManagers)

  const financeManagersOptions = useMemo(
    () =>
      financeManagers.map((item) => ({
        label: item.username,
        value: item.id,
      })),
    [financeManagers],
  )

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    if (!current) return false

    return current.isAfter(dayjs(), 'day')
  }

  const today = dayjs()
  const todayDate = today.toDate()
  const rangePresets: TimeRangePickerProps['presets'] = [
    {
      label: 'Предыдущий месяц',
      value: [
        dayjs(startOfMonth(subMonths(todayDate, 1))),
        dayjs(endOfMonth(subMonths(todayDate, 1))),
      ],
    },
    {
      label: 'Текущий месяц',
      value: [today.startOf('month'), today],
    },
    {
      label: 'Предыдущий квартал',
      value: [
        dayjs(startOfQuarter(subQuarters(todayDate, 1))),
        dayjs(endOfQuarter(subQuarters(todayDate, 1))),
      ],
    },
    {
      label: 'Текущий квартал',
      value: [dayjs(startOfQuarter(todayDate)), today],
    },
    {
      label: 'Произвольный период',
      value: [today, today],
    },
  ]

  useEffect(() => {
    if (hasFullAccess) {
      financeManagerMounted()
    }
  }, [hasFullAccess])

  return (
    <Space className={classname}>
      <RangePicker
        disabled={[false, !value.datePeriod?.[0]]}
        value={value.datePeriod}
        presets={rangePresets}
        disabledDate={disabledDate}
        onCalendarChange={(dates) => {
          if (!dates?.[0] || !dates?.[1]) {
            onChange({ ...value, datePeriod: dates })
          }
        }}
        onChange={(dates) => onChange({ ...value, datePeriod: dates })}
      />
      {hasFullAccess && (
        <Select
          allowClear
          placeholder="Select an user id"
          mode="multiple"
          options={financeManagersOptions}
          value={value.userIds}
          onChange={(ids) =>
            onChange({
              ...value,
              userIds: ids?.length ? ids : undefined,
            })
          }
          style={{ width: 400 }}
        />
      )}
    </Space>
  )
}
